import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as api from './apihandler';
import { MapAddressInput } from 'app/shared-html-components/address-map/address-map.component';
import { AssetOverview, CreateAsset, AssetById, UpdateAsset, AssetCases } from '../models/assets.models';
import { GoogleGeocoding } from '../models/google.results.models';
import { ServiceContract } from '../models/assetService.models';

export class AssetApi {
    constructor(private http: HttpClient) {}

    bearer = localStorage.getItem('bearer') as string;

    overview():Observable<AssetOverview[]>{
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<AssetOverview[]>(api.jubloApi + 'api/Assets/AssetsOverview', { headers })
    }

    createAsset(a: CreateAsset):Observable<void> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post<void>(api.jubloApi + 'api/Assets/CreateAsset' , a , {headers});
    }

    assetById(assetId: string):Observable<AssetById> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<AssetById>(api.jubloApi + 'api/Assets/AssetsById/' + assetId, {headers})
    }

    updateAsset(assetId:string, a:UpdateAsset):Observable<void>{
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.put<void>(api.jubloApi + `api/Assets/UpdateAsset/${ assetId }` , a ,{ headers});
    }
    
    deleteAsset(assetId:string):Observable<void>{
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.delete<void>(api.jubloApi + `api/Assets/DeleteAsset/${ assetId }`, { headers })
    }

    updateAssetCustomValue(assetId:string, fieldId:string, value:any):Observable<void>{
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post<void>(api.jubloApi + '/api/Assets/UpdateCustomFieldValue', {
            fieldId:fieldId,
            assetId:assetId,
            value: value.toString()
        } ,{ headers});
    }

    assetLocation(assetId:string):Observable<GoogleGeocoding> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<GoogleGeocoding>(api.jubloApi + `api/Assets/UpdateAssetLocation/${ assetId }`, { headers });
    }

    fileToAsset(assetId:string, files: string[]) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post(api.jubloApi + 'api/Assets/UploadFileToAsset',{
            assetId: assetId,
            files: files
        },{headers});
    }

    casesOnAsset(assetId: string):Observable<AssetCases[]> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<AssetCases[]>(api.jubloApi + `api/Assets/GetCasesByAssetId/${ assetId }`, {headers});
    }

    serviceOnAsset(assetId: string):Observable<ServiceContract> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<ServiceContract>(api.jubloApi + `api/Assets/GetServiceOnAsset/${ assetId }`, {headers});
    }

    upload(fileToUpload: File) {
        let input = new FormData();
        input.append("file", fileToUpload);
        return this.http.post(api.jubloApi + 'api/shared/attachments/file', input);
    }

    addSerialNumber(assetId:string, serialNumber:string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.patch(api.jubloApi + `api/Assets/AddLabelToAsset/${ assetId }/${ serialNumber }`, {}, { headers, observe: 'response' });
    }

    addAssetToProperty(prop:{assetId:string, propertyId:string, propertyLeaseId:string | null}){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post(api.jubloApi + 'api/PropertyLease/AddAssetToProperty',prop, {headers})
    }

    addImageToAsset(assetId:string, fileId:string){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.patch(api.jubloApi + `api/Assets/AddImageToAsset/${ assetId }/${ fileId }`,{},{ headers })
    }

    changeServiceOwner(assetId:string, companyId:string){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.patch(api.jubloApi + `api/Assets/ChangeAssetServiceOwner/${assetId}/${companyId}`,{},{headers})
    }

    changeInstallationContractor(assetId:string, companyId:string){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.patch(api.jubloApi + `api/Assets/ChangeInstallationContractor/${assetId}/${companyId}`,{},{headers})
    }

    func = new AssetFunctions();
}

class AssetFunctions {
    assetToMapAddress(asset: AssetById): MapAddressInput {
        return {
            name: asset.modelName ? asset.modelName : '',
            address : asset.address ? asset.address : '',
            zipCode : asset.zipCode ? asset.zipCode : '',
            city: asset.city ? asset.city : '',
            lat : asset.latitude!,
            long: asset?.longitude!
        }
    }
    assetByIdToUpdateAsset(a:AssetById): UpdateAsset {
        let d = {
            modelName: a.modelName ?  a.modelName! : '',
            serialNumber: a.serialNumber,
            warrantyDate: a.warrantyDate,
            year: a.year,
            address: a.address,
            zipCode: a.zipCode,
            city: a.city,
            remark: a.remark,
            customerOwnerId: null,
            companyOwnerId: null,
            installationContractor: !!a.installationContractor ? a.installationContractor.id : null,
            labelId: a.labelId,
            serviceOwner: !!a.serviceOwner ? a.serviceOwner.id : null,
            categoryId: !!a.category ? a.category.id : null,
            skillId: !!a.skill ? a.skill.id : null,
            customerFields: a.customFields?.map(x => {
                return {
                    typeId: x.typeId,
                    name: x.fieldName,
                    value: x.value
                }
            }),
            contactName: a.contactName,
            contactEmail: a.contactEmail,
            contactPhone: a.contactPhone,
        }
        return d;
    }

    arr2string(s:any): string {
        return s.join(';')
    }
}



